import { render, staticRenderFns } from "./step-custom-price.vue?vue&type=template&id=b40cde22&scoped=true&"
import script from "./step-custom-price.vue?vue&type=script&lang=js&"
export * from "./step-custom-price.vue?vue&type=script&lang=js&"
import style0 from "./step-custom-price.vue?vue&type=style&index=0&id=b40cde22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40cde22",
  null
  
)

export default component.exports